module.exports = __webpack_public_path__ + "static/greyelephant-4053e2bc7773d61f5b070537333b73ea.jpeg";